import { useQuery } from '@tanstack/react-query';
import { supabase } from 'lib/supabase';
import { useAuthContext } from 'context/authContext';
import useBranchPermission from './useBranchPermission';

/**
 * The country a branch operates in, taken from the branch's Location setting
 * (branches.location_id -> location.location_name). Ground-team (non-HQ)
 * users may only register beneficiaries in their own branch's country.
 */
export default function useBranchCountry() {
  const { isInitialized } = useAuthContext();
  const { branchId, isMainBranch } = useBranchPermission();

  const { data, isLoading } = useQuery({
    queryKey: ['branchCountry', branchId],
    queryFn: async () => {
      const { data: branch, error } = await supabase
        .from('branches')
        .select('id, name, location:location_id(location_name)')
        .eq('id', branchId)
        .single();
      if (error) return null;
      return branch?.location?.location_name || null;
    },
    enabled: isInitialized && !!branchId
  });

  return {
    branchCountry: data || null,
    // HQ can register children anywhere; branch staff are restricted
    restrictToBranchCountry: !isMainBranch && !!branchId,
    isLoading
  };
}
